import { Controller } from 'stimulus';
import toArray from '../helpers/toArray';
import getControllerForElement from '../helpers/getControllerForElement';

class BusinessToggle extends Controller {
  connect() {
    this.checkCompanyNameVisibility();
  }

  onOrderTypeChange() {
    this.checkCompanyNameVisibility();
    this.updateCountryVatController();
  }

  checkCompanyNameVisibility() {
    const selectedOrderType = this.element.querySelector('[name=order_type]:checked');
    const isCompanyNameTargetVisible = selectedOrderType.value === 'business';
    const companyNameInput = this.companyNameTarget.querySelector('input');

    companyNameInput.required = isCompanyNameTargetVisible;

    this.companyNameTarget.style.display = isCompanyNameTargetVisible ? 'block' : 'none';
  }

  updateCountryVatController() {
    const countryVatElements = toArray(document.querySelectorAll('[data-controller*="country-vat"]'));

    if (!countryVatElements.length) {
      return;
    }

    countryVatElements.forEach((countryVatElement) => {
      // Retrieve the controller for the element...
      getControllerForElement(this.application, countryVatElement, 'country-vat')
        .then((controller) => {
          // Call the onCountryChange method to reevaluate
          controller.onCountryChange();
        });
    });
  }
}

BusinessToggle.targets = [
  'companyName',
];

export default BusinessToggle;
